export var MixinBudgets = {
  data: () => ({
    B_BudgetsLoaded: false,
    TO_BudgetsList: [],
    O_BudgetsSelected: null,
    R_montantBudgetRemaining: 0,
    R_montantBudgetTotal: 0,
    BudgetsAllowed: false,
    L_BudgetsCounter: 0,
    L_TimeOut: 0,
    L_Limit: 0,
    L_Indice: 0
  }),
  methods: {
    BudgetsLoad(B_ForceUpdate = false) {
      if (!this.B_BudgetsLoaded || B_ForceUpdate) {
        var T_Token = "JWT " + this.$cookies.get("BackEndToken");
        return this.$BackEndAPI
          .get("budget/", { headers: { Authorization: T_Token } })
          .then(TO_Response => {
            this.TO_BudgetsList = [];
            if (TO_Response.data != "") {
              this.TO_BudgetsList = TO_Response.data;
            }
            this.B_BudgetsLoaded = true;
          })
          .catch(() => {
            this.$router.push({ name: "Disconnect" });
          });
      } else {
        // or return a new resolved promise
        return Promise.resolve();
      }
    },
    BudgetsLoadByPeriod(T_Period) {
      if (!this.B_BudgetsLoaded) {
        var T_Token = "JWT " + this.$cookies.get("BackEndToken");
        return this.$BackEndAPI
          .get("budget/?periode=" + T_Period, { headers: { Authorization: T_Token } })
          .then(TO_Response => {
            this.TO_BudgetsList = [];
            if (TO_Response.data != "") {
              for (var L_Index = 0; L_Index < TO_Response.data.length; L_Index++) {
                TO_Response.data[L_Index].search_ca = TO_Response.data[L_Index].libelle_CA + " " + TO_Response.data[L_Index].cpteAnalytique;
                TO_Response.data[L_Index].search_na = TO_Response.data[L_Index].libelle_nature + " " + TO_Response.data[L_Index].natureAnalytique;
              }
              this.TO_BudgetsList = TO_Response.data;
            }
            this.B_BudgetsLoaded = true;
          })
          .catch(() => {
            this.$router.push({ name: "Disconnect" });
          });
      } else {
        // or return a new resolved promise
        return Promise.resolve();
      }
    },
    BudgetsLoadByYear(T_Year) {
      if (!this.B_BudgetsLoaded) {
        var T_Token = "JWT " + this.$cookies.get("BackEndToken");
        return this.$BackEndAPI
          .get("budget/budgetlist/year/" + T_Year + "/", { headers: { Authorization: T_Token } })
          .then(TO_Response => {
            this.TO_BudgetsList = [];
            if (TO_Response.data != "") {
              for (var L_Index = 0; L_Index < TO_Response.data.length; L_Index++) {
                TO_Response.data[L_Index].search_ca = TO_Response.data[L_Index].libelle_CA + " " + TO_Response.data[L_Index].cpteAnalytique;
                TO_Response.data[L_Index].search_na = TO_Response.data[L_Index].libelle_nature + " " + TO_Response.data[L_Index].natureAnalytique;
              }
              this.TO_BudgetsList = TO_Response.data;
            }
            this.B_BudgetsLoaded = true;
          })
          .catch(() => {
            this.$router.push({ name: "Disconnect" });
          });
      } else {
        // or return a new resolved promise
        return Promise.resolve();
      }
    },
    BudgetsLoadByYearAndUser(T_Year) {
      if (!this.B_BudgetsLoaded) {
        var T_Token = "JWT " + this.$cookies.get("BackEndToken");
        return this.$BackEndAPI
          .get("budget/budgetlist/user/year/" + T_Year + "/", { headers: { Authorization: T_Token } })
          .then(TO_Response => {
            this.TO_BudgetsList = [];
            if (TO_Response.data != "") {
              for (var L_Index = 0; L_Index < TO_Response.data.length; L_Index++) {
                TO_Response.data[L_Index].search_ca = TO_Response.data[L_Index].libelle_CA + " " + TO_Response.data[L_Index].cpteAnalytique;
                TO_Response.data[L_Index].search_na = TO_Response.data[L_Index].libelle_nature + " " + TO_Response.data[L_Index].natureAnalytique;
              }
              this.TO_BudgetsList = TO_Response.data;
            }
            this.B_BudgetsLoaded = true;
          })
          .catch(() => {
            this.$router.push({ name: "Disconnect" });
          });
      } else {
        // or return a new resolved promise
        return Promise.resolve();
      }
    },
    BudgetsLoadByYearAndAACode(T_Year, T_AACode) {
      if (!this.B_BudgetsLoaded) {
        var T_Token = "JWT " + this.$cookies.get("BackEndToken");
        return this.$BackEndAPI
          .get("budget/budgetlist/year/" + T_Year + "/aacode/" + T_AACode + "/", { headers: { Authorization: T_Token } })
          .then(TO_Response => {
            this.TO_BudgetsList = [];
            if (TO_Response.data != "") {
              for (var L_Index = 0; L_Index < TO_Response.data.length; L_Index++) {
                TO_Response.data[L_Index].search_ca = TO_Response.data[L_Index].libelle_CA + " " + TO_Response.data[L_Index].cpteAnalytique;
                TO_Response.data[L_Index].search_na = TO_Response.data[L_Index].libelle_nature + " " + TO_Response.data[L_Index].natureAnalytique;
              }
              this.TO_BudgetsList = TO_Response.data;
            }
            this.B_BudgetsLoaded = true;
          })
          .catch(() => {
            this.$router.push({ name: "Disconnect" });
          });
      } else {
        // or return a new resolved promise
        return Promise.resolve();
      }
    },
    BudgetsLoadByYearAndAACodeAndUser(T_Year, T_AACode) {
      if (!this.B_BudgetsLoaded) {
        var T_Token = "JWT " + this.$cookies.get("BackEndToken");
        return this.$BackEndAPI
          .get("budget/budgetlist/user/year/" + T_Year + "/aacode/" + T_AACode, { headers: { Authorization: T_Token } })
          .then(TO_Response => {
            this.TO_BudgetsList = [];
            if (TO_Response.data != "") {
              for (var L_Index = 0; L_Index < TO_Response.data.length; L_Index++) {
                TO_Response.data[L_Index].search_ca = TO_Response.data[L_Index].libelle_CA + " " + TO_Response.data[L_Index].cpteAnalytique;
                TO_Response.data[L_Index].search_na = TO_Response.data[L_Index].libelle_nature + " " + TO_Response.data[L_Index].natureAnalytique;
              }
              this.TO_BudgetsList = TO_Response.data;
            }
            this.B_BudgetsLoaded = true;
          })
          .catch(() => {
            this.$router.push({ name: "Disconnect" });
          });
      } else {
        // or return a new resolved promise
        return Promise.resolve();
      }
    },
    BudgetsLoadByUser() {
      if (!this.B_BudgetsLoaded) {
        var T_Token = "JWT " + this.$cookies.get("BackEndToken");
        return this.$BackEndAPI
          .get("budget/budgetlist/", { headers: { Authorization: T_Token }, timeout: 300000 })
          .then(TO_Response => {
            this.TO_BudgetsList = [];
            if (TO_Response.data != "") {
              this.TO_BudgetsList = TO_Response.data;
            }
            this.B_BudgetsLoaded = true;
          })
          .catch(() => {
            this.$router.push({ name: "Disconnect" });
          });
      } else {
        // or return a new resolved promise
        return Promise.resolve();
      }
    },
    BudgetsLoadByUserYearAndAACode(L_UserID, T_Year, T_AACode) {
      //if (!this.B_BudgetsLoaded) {
      var T_Token = "JWT " + this.$cookies.get("BackEndToken");
      var self = this;
      return this.$BackEndAPI
        .get("budget/budgetlist/user/year/" + T_Year + "/aacode/" + T_AACode, { headers: { Authorization: T_Token } })
        .then(TO_Response => {
          self.TO_BudgetsList = [];
          if (TO_Response.data != "") {
            self.TO_BudgetsList = TO_Response.data;
          }
          //self.B_BudgetsLoaded = true;
          //self.L_Indice++;
        })
        .catch(() => {
          self.$router.push({ name: "Disconnect" });
        });
      //}
    },
    BudgetsLoadByUserApprob() {
      if (!this.B_BudgetsLoaded) {
        var T_Token = "JWT " + this.$cookies.get("BackEndToken");
        return this.$BackEndAPI
          .get("budget/budgetlistApprob/", { headers: { Authorization: T_Token } })
          .then(TO_Response => {
            this.TO_BudgetsList = [];
            if (TO_Response.data != "") {
              this.TO_BudgetsList = TO_Response.data;
            }
            this.B_BudgetsLoaded = true;
          })
          .catch(() => {
            this.$router.push({ name: "Disconnect" });
          });
      } else {
        // or return a new resolved promise
        return Promise.resolve();
      }
    },
    BudgetsLoadByUserApprobYear(T_Year) {
      if (!this.B_BudgetsLoaded) {
        var T_Token = "JWT " + this.$cookies.get("BackEndToken");
        return this.$BackEndAPI
          .get("budget/budgetlistApprob/user/year/" + T_Year, { headers: { Authorization: T_Token } })
          .then(TO_Response => {
            this.TO_BudgetsList = [];
            if (TO_Response.data != "") {
              this.TO_BudgetsList = TO_Response.data;
            }
            this.B_BudgetsLoaded = true;
          })
          .catch(() => {
            this.$router.push({ name: "Disconnect" });
          });
      } else {
        // or return a new resolved promise
        return Promise.resolve();
      }
    },
    BudgetsReLoad() {
      this.B_BudgetsLoaded = false;
      this.BudgetsLoad();
    },
    BudgetsGet() {
      this.BudgetsLoad();
      return this.TO_BudgetsList;
    },
    BudgetsFilterGetByPeriod(T_Period) {
      // filtrer les budgets sur les périodes (afin de récupérer la liste des comptes)
      var TO_Budgets = [];
      this.BudgetsLoad();
      var L_Index;
      for (L_Index = 0; L_Index < this.TO_BudgetsList.length; L_Index++) {
        var O_Budget = this.TO_BudgetsList[L_Index];
        //if (O_Budget.periode == T_Period) {
        if (O_Budget.periode.substring(0, 2) == T_Period) {
          // Correspond à la période voulue
          TO_Budgets.push(O_Budget);
        }
      }
      return TO_Budgets;
    },
    BudgetsFilterGetByPeriodYear(T_PeriodYear) {
      // filtrer les budgets sur les périodes (afin de récupérer la liste des comptes)
      var TO_Budgets = [];
      this.BudgetsLoad(true);
      var L_Index;
      for (L_Index = 0; L_Index < this.TO_BudgetsList.length; L_Index++) {
        var O_Budget = this.TO_BudgetsList[L_Index];
        if (O_Budget.periode.substring(0, 2) == T_PeriodYear) {
          // Correspond à la période voulue
          TO_Budgets.push(O_Budget);
        }
      }
      return TO_Budgets;
    },
    BudgetsFilterGetByAccount(T_Period, T_Compte) {
      // filtrer les budgets sur les comptes et périodes (afin de récupérer la liste des natures)
      var TO_Budgets = [];
      this.BudgetsLoad();
      var L_Index;
      for (L_Index = 0; L_Index < this.TO_BudgetsList.length; L_Index++) {
        var O_Budget = this.TO_BudgetsList[L_Index];
        //if (O_Budget.periode == T_Period) {
        if (O_Budget.periode.substring(0, 2) == T_Period) {
          // Correspond à la période voulue
          if (O_Budget.cpteAnalytique == T_Compte) {
            // Correspond au compte voulu
            TO_Budgets.push(O_Budget);
          }
        }
      }
      TO_Budgets.sort((a, b) => (a.libelle_nature > b.libelle_nature ? 1 : b.libelle_nature > a.libelle_nature ? -1 : 0));
      return TO_Budgets;
    },

    BudgetsFilterGetByPeriodYearAccount(T_PeriodYear, T_Compte) {
      // filtrer les budgets sur le compte et la période (afin de récupérer la liste des natures)
      var TO_Budgets = [];
      this.BudgetsLoad();
      var L_Index;
      for (L_Index = 0; L_Index < this.TO_BudgetsList.length; L_Index++) {
        var O_Budget = this.TO_BudgetsList[L_Index];
        if (O_Budget.periode.substring(0, 2) == T_PeriodYear) {
          // Correspond à la période voulue
          if (O_Budget.cpteAnalytique == T_Compte) {
            // Correspond au compte voulu
            TO_Budgets.push(O_Budget);
          }
        }
      }
      TO_Budgets.sort((a, b) => (a.libelle_nature > b.libelle_nature ? 1 : b.libelle_nature > a.libelle_nature ? -1 : 0));
      return TO_Budgets;
    },

    BudgetsFilterGetByPeriodYearAccountUser(T_PeriodYear, T_Compte) {
      // Filtrer les budgets sur le compte, la période et l'utilisateur (pour récupérer la liste des natures)
      //this.TO_BudgetsList = [];
      var TO_Budgets = [];
      var T_Token = "JWT " + this.$cookies.get("BackEndToken");
      var self = this;
      return this.$BackEndAPI
        .get("budget/budgetlist/user/year/" + T_PeriodYear + "/aacode/" + T_Compte, { headers: { Authorization: T_Token } })
        .then(function(TO_Response) {
          //console.log(TO_Response.data);
          if (TO_Response.data != "") {
            //self.TO_BudgetsList = TO_Response.data;
            TO_Budgets = TO_Response.data;
          } else {
            //self.TO_BudgetsList = [];
          }
          //return self.TO_BudgetsList;
          return TO_Budgets;
        })
        .catch(() => {
          self.$router.push({ name: "Disconnect" });
        })
        .finally(() => {
          //alert('End');
        });
    },

    BudgetsGetFKAccount(T_Compte) {
      // Récupérer le code FK à partir du code du compte
      var T_FKCpteAnal = "";

      var L_Index;
      for (L_Index = 0; L_Index < this.TO_BudgetsList.length; L_Index++) {
        var O_Budget = this.TO_BudgetsList[L_Index];

        if (O_Budget.cpteAnalytique == T_Compte) {
          // Correspond au compte voulu
          T_FKCpteAnal = O_Budget.fk_CpteAnalytique;
          L_Index = this.TO_BudgetsList.length; // On arrête la boucle
        }
      }

      return T_FKCpteAnal;
    },
    BudgetsGetFKNature(T_Nature) {
      // Récupérer le code FK à partir du code Nature
      var T_FKNatureAnal = "";

      var L_Index;
      for (L_Index = 0; L_Index < this.TO_BudgetsList.length; L_Index++) {
        var O_Budget = this.TO_BudgetsList[L_Index];

        if (O_Budget.natureAnalytique == T_Nature) {
          // Correspond a la Nature voulue
          T_FKNatureAnal = O_Budget.fk_NatureAnalytique;
          L_Index = this.TO_BudgetsList.length; // On arrête la boucle
        }
      }

      return T_FKNatureAnal;
    },
    BudgetsGetID(T_Period, T_Compte, T_Nature) {
      // Récupérer l'ID du Budget à partir de la période, du compte et de la nature
      var L_ID = 0;

      var L_Index;
      for (L_Index = 0; L_Index < this.TO_BudgetsList.length; L_Index++) {
        var O_Budget = this.TO_BudgetsList[L_Index];

        if (O_Budget.periode == T_Period) {
          // Correspond à la période voulue
          if (O_Budget.cpteAnalytique == T_Compte) {
            // Correspond au compte voulu
            if (O_Budget.natureAnalytique == T_Nature) {
              // Correspond à la nature voulue
              this.O_BudgetsSelected = O_Budget;
              L_ID = O_Budget.id;
              L_Index = this.TO_BudgetsList.length; // On arrête la boucle
            }
          }
        }
      }

      return L_ID;
    },
    BudgetsGetIDFromNature(T_Nature, TO_AnalyticNatureList) {
      // Récupérer l'ID du Budget à partir de la nature dans la liste des natures disponibles
      var L_ID = 0;
      var L_Index;
      for (L_Index = 0; L_Index < TO_AnalyticNatureList.length; L_Index++) {
        var O_Budget = TO_AnalyticNatureList[L_Index];
        if (O_Budget.natureAnalytique == T_Nature) {
          // Correspond à la nature voulue
          this.O_BudgetsSelected = O_Budget;
          L_ID = O_Budget.id;
          L_Index = TO_AnalyticNatureList.length; // On arrête la boucle
        }
      }
      return L_ID;
    },
    BudgetsGetMontantFromSelected() {
      return this.O_BudgetsSelected.montant;
    },
    BudgetsHowFarOut(L_BudgetID, R_Montant = 0, L_EngageID = 0) {
      this.L_BudgetsCounter = 0;
      this.R_montantBudgetTotal = 0;
      this.R_montantBudgetRemaining = 0;

      if (L_BudgetID > 0) {
        var data = {};
        if (L_EngageID > 0) {
          data.excludeEngagements = [L_EngageID];
        }

        var T_Token = "JWT " + this.$cookies.get("BackEndToken");
        return this.$BackEndAPI
          .post("budget/" + L_BudgetID + "/totals/", data, { headers: { Authorization: T_Token } })
          .then(response => {
            this.R_montantBudgetTotal = response.data.montant_budget.toFixed(2);
            this.R_montantBudgetRemaining = (response.data.montant_restant_budget - R_Montant).toFixed(2);
            this.L_BudgetsCounter = response.data.engagements_count_budget;
          })
          .catch(() => {
            this.$router.push({ name: "Disconnect" });
          });
      } else {
        // or return a new resolved promise
        return Promise.resolve();
      }
    },
    BudgetsIsAllowed(L_BudgetID, L_UserID) {
      this.BudgetsAllowed = false;
      var T_Token = "JWT " + this.$cookies.get("BackEndToken");
      this.$BackEndAPI
        .get("autorisation/", { headers: { Authorization: T_Token } })
        .then(response => {
          if (response.data != "") {
            var AuthorizeList = response.data;
            var L_Index;
            for (L_Index = 0; L_Index < AuthorizeList.length; L_Index++) {
              var O_Auth = AuthorizeList[L_Index];
              if (O_Auth.fk_Budget == L_BudgetID && O_Auth.fk_User == L_UserID && O_Auth.type == 1) {
                this.BudgetsAllowed = true;
              }
            }
          }
        })
        .catch(() => {
          this.$router.push({ name: "Disconnect" });
        });
    }
  }
};
